import React, { useCallback } from "../../../__compat__/react/main.entry.mjs.mjs";
import { useLocale } from "../../LocaleProvider/index.mjs.mjs";
import { Tray } from "../Tray/index.mjs.mjs";
import { StyledTitleBarButton, StyledCancelIcon, StyledTitle, StyledTitleBar, } from "./MobileOverlay.styles.mjs.mjs";
const noop = () => { };
const CancelIcon = (props) => (React.createElement(StyledCancelIcon, { "aria-hidden": "true", width: "24", height: "24", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M5.9,17.1 L17.1,5.9 M5.9,5.9 L17.1,17.1", stroke: "currentColor", strokeWidth: "1", fill: "none", fillRule: "evenodd" })));
export const MobileOverlay = ({ children, onClose = noop, onConfirm = noop, open }) => {
    const { datePicker: locale } = useLocale();
    const overlayRef = React.useRef(null);
    const handleClose = useCallback(onClose, [onClose]);
    const handleConfirm = useCallback(onConfirm, [onConfirm]);
    return (React.createElement(Tray, { "aria-label": locale.calendarOverlayLabel, open: open, onClose: handleClose, ref: overlayRef },
        React.createElement(StyledTitleBar, null,
            React.createElement(StyledTitleBarButton, { type: "button", onClick: handleClose, "aria-label": locale.cancelLabel },
                React.createElement(CancelIcon, null)),
            React.createElement(StyledTitle, { "aria-hidden": "true" }, locale.calendarOverlayLabel),
            React.createElement(StyledTitleBarButton, { type: "button", onClick: handleConfirm }, locale.confirmLabel)),
        children));
};
//# sourceMappingURL=MobileOverlay.mjs.mjs.map